import { Callout } from '@radix-ui/themes'
import { ExclamationTriangleIcon } from '@radix-ui/react-icons'

interface MessageCalloutProps {
  color: 'red' | 'amber'
  message: string
}

export const MessageCallout = ({ color, message }: MessageCalloutProps) => (
  <Callout.Root color={color} size="1">
    <Callout.Icon>
      <ExclamationTriangleIcon />
    </Callout.Icon>
    <Callout.Text>{message}</Callout.Text>
  </Callout.Root>
)
